<template>
  <div class="banner-useful-files-content">
    <div class="banner-image" :style="{ backgroundImage: `url(${bannerImageSrc})` }"></div>
    <div class="overlay-image">
      <h1 class="banner-title">{{ bannerImageTitle }}</h1>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import UsefulFilesPageMixin from '@/mixins/useful-files-page-mixin'
import { UsefulFilesPageStore } from '@/store/useful-files-page/useful-files-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class BannerUsefulFilesSection extends Mixins(UsefulFilesPageMixin) {
  usefulFilesPageStore: PageStoreContract = getModule(UsefulFilesPageStore, this.$store)

  get bannerImageTitle(): string {
    return this.getElementTitle(0, 0)
  }

  get bannerImageSrc(): string {
    return this.getElementMedia(0, 0)
  }

  async getUsefulFilesPage(): Promise<void> {
    await this.usefulFilesPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.usefulFilesPageStore.isLoading) {
      await this.getUsefulFilesPage()
    }
  }
}
</script>

<style lang="scss">
.banner-useful-files-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: gray;
  width: 100% !important;
  max-height: 28rem;
}

.banner-image {
  position: relative;
  width: 100%;
  height: 451px;

  background-size: cover;

  background-repeat: no-repeat;
  background-position: center;
}

.overlay-image {
  position: absolute;
  bottom: 5.5rem;
  left: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  z-index: 1;
  pointer-events: none;
  text-align: left;
}

.banner-title {
  font-size: 8rem;
  width: 1rem;
  margin: 0;
  font-weight: 400;
  line-height: 7.25rem;
  letter-spacing: -0.01em;
  text-align: left;

}

@media (min-width: 1726px) {
  .banner-useful-files-content {
    width: 100%;
  }
}
</style>
